<!-- =========================================================================================
  File Name:
  Description:
  ----------------------------------------------------------------------------------------
  Item Name: GetBoarded UI Template
  Author: GetBoarded
  Author URL: https://www.getboarded.com
========================================================================================== -->

<template>
  <div id="user-edit-tab-info">
    <!-- Avatar Row -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="flex items-start flex-col sm:flex-row">
          <img :src="data_local.avatar" class="mr-8 rounded h-24 w-24" />
          <!-- <vs-avatar :src="data.avatar" size="80px" class="mr-4" /> -->
          <div>
            <p class="text-lg font-medium mb-2 mt-4 sm:mt-0">
              {{ data_local.firstName }} {{ data_local.lastName }}
            </p>
            <img src="" class="before" style="display:none;"/>
            <canvas style="display: none;"></canvas>
            <img src="" class="after" style="display:none;"/>
            <input
              type="file"
              class="hidden"
              ref="update_avatar_input"
              @change="update_avatar"
              accept="image/*"
            />

            <!-- Toggle comment of below buttons as one for actual flow & currently shown is only for demo -->
            <!--<vs-button class="mr-4 mb-4">Change Avatar</vs-button>-->
            <vs-button
              type="filled"
              class="mr-4"
              size="small"
              @click="$refs.update_avatar_input.click()"
              >{{ $t("profile.account.a1") }}</vs-button
            >
            <vs-button type="border" color="primary" size="small" @click="changePasswordPrompt = true"
              >{{ $t("profile.account.a2") }}</vs-button
            >
            <vs-prompt
              color="primary"
              :title="$t('profile.account.a2')"
              :accept-text="$t('Submit')"
              :cancel-text="$t('Cancel')"
              @cancel="oldPassword='', newPassword='', confirmPassword=''"
              @accept="change_password"
              @close="oldPassword='', newPassword='', confirmPassword='', changePasswordPrompt = false"
              :active.sync="changePasswordPrompt"
            >
              <!--<div class="vx-card__title mb-8">
                <h4 class="mb-4">Reset Password</h4>
                <p>Please enter your new password.</p>
              </div>-->
              <!--<vs-input
                type="password"
                :label-placeholder="$t('profile.account.a3')"
                v-model="oldPassword"
                class="w-full mb-6"
              />-->
              <vs-input
                type="password"
                :label-placeholder="$t('profile.account.a4')"
                v-model="newPassword"
                class="w-full mb-6"
              />
              <vs-input
                type="password"
                :label-placeholder="$t('profile.account.a5')"
                v-model="confirmPassword"
                class="w-full mb-8"
              />
            </vs-prompt>
          </div>
        </div>
      </div>
    </div>

    <!-- Content Row -->
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full">
        <vs-input
          class="w-full mt-4"
          :label="$t('profile.p1')"
          v-model="data_local.username"
          v-validate="'required|alpha_num'"
          name="username"
        />
        <span class="text-danger text-sm" v-show="errors.has('username')">{{
          errors.first("username")
        }}</span>

        <div class="vx-row">
          <vs-input
            class="vx-col md:w-1/2 w-full mt-4"
            :label="$t('profile.account.a6')"
            v-model="data_local.firstName"
            v-validate="'required|alpha_spaces'"
            name="first_name"
          />
          <span class="text-danger text-sm" v-show="errors.has('name')">{{
            errors.first("first_name")
          }}</span>

          <vs-input
            class="vx-col md:w-1/2 w-full mt-4"
            :label="$t('profile.account.a7')"
            v-model="data_local.lastName"
            v-validate="'required|alpha_spaces'"
            name="last_name"
          />
          <span class="text-danger text-sm" v-show="errors.has('name')">{{
            errors.first("last_name")
          }}</span>
        </div>

        <vs-input
          class="w-full mt-4"
          :label="$t('profile.p3')"
          v-model="data_local.email"
          type="email"
          v-validate="'required|email'"
          name="email"
          disabled
        />
        <span class="text-danger text-sm" v-show="errors.has('email')">{{
          errors.first("email")
        }}</span>
      </div>

      <div class="vx-col md:w-1/2 w-full">
        <div class="mt-4">
          <label class="vs-input&#45;&#45;label">{{$t('profile.p4')}}</label>
          <v-select
            v-model="status_local"
            :clearable="false"
            :options="statusOptions"
            v-validate="'required'"
            name="status"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
          />
          <span class="text-danger text-sm" v-show="errors.has('status')">{{
            errors.first("status")
          }}</span>
        </div>
        <div class="mt-4">
          <span>{{$t('adduser.lbl5')}}</span>
          <div class="grid-layout-container alignment-block mt-2">
            <vs-row
              vs-align="flex-end"
              vs-type="flex"
              vs-justify=""
              vs-w="12"
            >
              <vs-switch color="success" v-model="lang"  name="lang" >
                <span  slot="on">SP</span>
                <span  slot="off">EN</span>
              </vs-switch>
            </vs-row>
        </div>
</div>
<div class="mt-4">
          <vs-input
            class="w-full mt-4"
            label="Meeting URL"
            v-model="data_local.meetingUrl"
            v-validate="'url'"
            name="meetingUrl"
            placeholder="https://app.decast.live/r/..."
          />
          <span class="text-danger text-sm" v-show="errors.has('meetingUrl')">
            {{ errors.first("meetingUrl") }}
          </span>
        </div>




        <!--<div class="mt-4">
          <label class="vs-input&#45;&#45;label">Role</label>
          <v-select v-model="role_local" :clearable="false" :options="roleOptions" v-validate="'required'" name="role" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          <span class="text-danger text-sm"  v-show="errors.has('role')">{{ errors.first('role') }}</span>
        </div>-->

        <!--<vs-input
          class="w-full mt-4"
          label="Company"
          v-model="data_local.company"
          v-validate="'alpha_spaces'"
          name="company"
        />
        <span class="text-danger text-sm" v-show="errors.has('company')">{{
          errors.first("company")
        }}</span>-->
      </div>
    </div>

    <!-- Permissions -->
    <!--<vx-card class="mt-base" no-shadow card-border>

      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="flex items-end px-3">
            <feather-icon svgClasses="w-6 h-6" icon="LockIcon" class="mr-2" />
            <span class="font-medium text-lg leading-none">Permissions</span>
          </div>
          <vs-divider />
        </div>
      </div>

      <div class="block overflow-x-auto">
        <table class="w-full">
          <tr>
            &lt;!&ndash;
              You can also use `Object.keys(Object.values(data_local.permissions)[0])` this logic if you consider,
              our data structure. You just have to loop over above variable to get table headers.
              Below we made it simple. So, everyone can understand.
             &ndash;&gt;
            <th class="font-semibold text-base text-left px-3 py-2" v-for="heading in ['Module', 'Read', 'Write', 'Create', 'Delete']" :key="heading">{{ heading }}</th>
          </tr>

          <tr v-for="(val, name) in data_local.permissions" :key="name">
            <td class="px-3 py-2">{{ name }}</td>
            <td v-for="(permission, name) in val" class="px-3 py-2" :key="name+permission">
              <vs-checkbox v-model="val[name]" />
            </td>
          </tr>
        </table>
      </div>

    </vx-card>-->

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
            class="ml-auto mt-2"
            @click="save_changes"
            :disabled="!validateForm"
            >{{ $t('profile.p23') }}</vs-button
          >
          <vs-button
            class="ml-4 mt-2"
            type="border"
            color="warning"
            @click="reset_data"
            >{{ $t('profile.p24') }}</vs-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";

// Store Module
// import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'

export default {
  components: {
    vSelect
  },
  props: ["data"],
  data() {
    return {
      changePasswordPrompt: false,
      data_local: JSON.parse(JSON.stringify(this.data)),
      oldPassword: null,
      newPassword: null,
      confirmPassword: null,
      lang:'',


      statusOptions: [
        { label: this.$t('profile.account.a8'), value: "active" }, // user has accepted the email and is active
        { label: this.$t('profile.account.a9'), value: "blocked" }, // user is blocked from using the app
        { label: this.$t('profile.account.a10'), value: "deactivated" } // mail has been sent, but user hasn't accepted it yet
      ],
      roleOptions: [
        { label: "Admin", value: "admin" },
        { label: "User", value: "user" },
        { label: "Staff", value: "staff" }
      ]
    };
  },
  computed: {
    status_local: {
      get() {
        return {
          label: this.capitalize(this.data_local.status),
          value: this.data_local.status
        };
      },
      set(obj) {
        this.data_local.status = obj.value;
      }
    },
    role_local: {
      get() {
        return {
          label: this.capitalize(this.data_local.role),
          value: this.data_local.role
        };
      },
      set(obj) {
        this.data_local.role = obj.value;
      }
    },
    validateForm() {
      return !this.errors.any();
    }
  },
  methods: {
    capitalize(str) {
      if (str !== undefined)
        return str.slice(0, 1).toUpperCase() + str.slice(1, str.length);
      else return str;
    },
    change_password() {
      console.log("local data", this.data_local);
      this.oldPassword = this.newPassword
      if(this.oldPassword !== null && this.newPassword !== null && this.confirmPassword !== null) {
        if(this.newPassword === this.confirmPassword) {
          this.data_local["password"] = this.newPassword;
          console.log("change password", this.data_local)
        }
      }
      console.log("local data password", this.data_local);
      this.oldPassword = null
      this.newPassword = null
      this.confirmPassword = null

      this.$store
        .dispatch("userManagement/updateUser", this.data_local)
        .then(res => {
          console.log("going to update tab account user", res);
          this.$vs.notify({
            color: "primary",
            title: this.$t("profile.account.a11"),
            text: this.$t("profile.account.a12")
          });
        })
        .catch(err => {
          console.error(err);
          this.$vs.notify({
            color: "danger",
            title: this.$t("profile.account.a13"),
            text: this.$t("profile.account.a14")
          });
        });
    },
    save_changes() {
      /* eslint-disable */
      if (!this.validateForm) return;

      // Here will go your API call for updating data
      // You can get data in "this.data_local"

      /* eslint-enable */
      if(this.lang===false){
        this.data_local.lang='en';
        this.lang=false;
      }else{
        this.data_local.lang='sp';
        this.lang=true;
      }


      console.log(this.lang,this.data_local.lang);




      console.log("local data", this.data_local);

      this.$store
        .dispatch("userManagement/updateUser", this.data_local)
        .then(res => {
          console.log("going to update tab account user", res);
          this.$vs.notify({
            color: "primary",
            title: this.$t("msg.msg1.suc_title"),
            text: this.$t("msg.msg1.suc_desc")
          });
        })
        .catch(err => {
          console.error(err);
          this.$vs.notify({
            color: "danger",
            title: this.$t("msg.msg1.err_title"),
            text: this.$t("msg.msg1.err_desc")
          });
        });
    },
    reset_data() {
      this.data_local = JSON.parse(JSON.stringify(this.data));
    },
    // update_avatar(input) {
    //   // You can update avatar Here
    //   // For reference you can check dataList example
    //   // We haven't integrated it here, because data isn't saved in DB
    //   if (input.target.files && input.target.files[0]) {
    //     const reader = new FileReader();
    //     reader.onload = e => {
    //       this.dataImg = e.target.result;
    //       this.data_local.avatar = this.dataImg;
    //     };
    //     reader.readAsDataURL(input.target.files[0]);
    //     console.log("image upload", reader);
    //   }
    // }
    update_avatar(input) {

      // You can update avatar Here
      // For reference you can check dataList example
      // We haven't integrated it here, because data isn't saved in DB


      if (input.target.files && input.target.files[0]) {


        const reader = new FileReader();
        console.log(input.target.files[0]);
        reader.readAsDataURL(input.target.files[0]);
        reader.onload = event => {
          const img = document.querySelector("img.before");
          img.src = event.target.result;
          // console.log(img.src);
          //img.style = "display: true";
          img.onload = () => {
            const width = img.width;
            const height = img.height;
            const elem = document.querySelector('canvas');
            elem.width = width;
            elem.height = height;
            const ctx = elem.getContext('2d');
            ctx.drawImage(img, 0, 0, width, height);
            const webp = ctx.canvas.toDataURL("image/webp", 0.5);
            const imgAfter = document.querySelector("img.after");
            imgAfter.src = webp;
            // imgAfter.style = "display: true";
            const head = 'data:image/webp;base64,';
            const imgFileSize = (Math.round((webp.length - head.length) * 3 / 4) / (1000)).toFixed(2);
            this.dataImg = imgAfter.src;
            this.data_local.avatar = this.dataImg;
            const imgFilebefroeSize= (input.target.files[0].size/(1024*1000)).toFixed(3);
            console.log(imgAfter.src,'actual-image-size:'+imgFilebefroeSize+'mb '+' after compress image size:',imgFileSize+'kb');
          },
            reader.onerror = error => console.error(error);
        }
        // document.querySelector("input[name=upload-image]")
        //   .addEventListener("change", (event) => ReadAndCompress(event))

        // reader.onload = e => {
        //   this.dataImg = e.target.result;
        //
        //   this.data_local.avatar = this.dataImg;
        //   img.src = e.target.result;
        //   //img.style = "display: true";
        //   img.onload = () => {
        //     const width = img.width;
        //     const height = img.height;
        //     const elem = document.querySelector('canvas');
        //     elem.width = width;
        //     elem.height = height;
        //     const ctx = elem.getContext('2d');
        //     ctx.drawImage(img, 0, 0, width, height);
        //     const webp = ctx.canvas.toDataURL("image/webp", 0.5);
        //     const imgAfter = document.querySelector("img.after");
        //     imgAfter.src = webp;
        //     //imgAfter.style = "display: true";
        //     const head = 'data:image/webp;base64,';
        //     const imgFileSize = (Math.round((webp.length - head.length) * 3 / 4) / (1000)).toFixed(2);
        //     console.log(imgFileSize);
        //   }
        // };
        //reader.readAsDataURL(input.target.files[0]);
        console.log("image upload", reader);
      }
    }
  },
  created() {
    if(this.data_local.lang==='en'){
      this.lang=false;
    }else{
      this.lang=true;
    }
    // Register Module UserManagement Module
    /*if (!moduleUserManagement.isRegistered) {
      this.$store.registerModule('userManagement', moduleUserManagement)
      moduleUserManagement.isRegistered = true
    }*/
    // this.fetch_user_data(this.$route.params.userId)
  },
  mounted() {}
};
</script>
